<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="ml mr mt">
  <well-page-title [subtitle]="'company.menu.companyProfile' | translate"
                    [title]="'company.menu.roleConfiguration' | translate">
  </well-page-title>

  <auth-role-configuration-view [assignedRightsMap]="assignedRightsMap"
                                [roleWithRightVOs]="roleWithRightVOs ?? []"
                                [editedRole]="editedRole"
                                [isPlatformAdmin]="hasSelectItemsAdminRights ?? false"
                                [editMode]="editMode"
                                (duplicate)="onDuplicate($event)"
                                (edit)="onEdit($event)"
                                (delete)="onDelete($event)"
                                (submitRole)="onSubmitRole($event)"
                                [showCompanyTypeDropdownForPlatform]="true"
                                [companyTypeOptions]="companyTypesSelectItems"
                                [companyTypeTranslationMap]="companyTypeTranslationMap"

  >

  </auth-role-configuration-view>
</div>


